export const PREVIOUS_CAMPAIGN_ISAD = {
  A: 18,
  B: 22,
  C: 20,
  D: 25,
  E: 15,
};

const now = Date.now();
const h = (n) => new Date(now - n * 3600000).toISOString();

export const RECENT_RECLASSIFICATIONS = [
  {
    id: "RC-001",
    segmentId: "N550-SEG-005",
    kmRange: "km 41–48",
    from: "C",
    to: "E",
    timestamp: h(6),
  },
  {
    id: "RC-002",
    segmentId: "N550-SEG-010",
    kmRange: "km 87–94",
    from: "B",
    to: "D",
    timestamp: h(18),
  },
  {
    id: "RC-003",
    segmentId: "N550-SEG-002",
    kmRange: "km 12–19",
    from: "C",
    to: "B",
    timestamp: h(48),
  },
  {
    id: "RC-004",
    segmentId: "N550-SEG-014",
    kmRange: "km 121–134",
    from: "C",
    to: "D",
    timestamp: h(72),
  },
  {
    id: "RC-005",
    segmentId: "N550-SEG-008",
    kmRange: "km 68–75",
    from: "B",
    to: "A",
    timestamp: h(120),
  },
];

export const RECENT_ANOMALIES = [
  {
    id: "AN-001",
    segmentId: "N550-SEG-011",
    kmRange: "km 98–105",
    description: "Sudden ISAD drop detected",
    timestamp: h(3),
  },
  {
    id: "AN-002",
    segmentId: "N550-SEG-004",
    kmRange: "km 33–41",
    description: "Pavement crack cluster",
    timestamp: h(12),
  },
  {
    id: "AN-003",
    segmentId: "N550-SEG-007",
    kmRange: "km 61–68",
    description: "Rutting threshold exceeded",
    timestamp: h(26),
  },
];

export const ACTIVE_ALERTS = { high: 2, medium: 5, low: 8 };
